import {Component} from '@angular/core';

@Component({
    selector: 'prism-confirm-disconnect-xero',
    templateUrl: './confirm-disconnect-xero.component.html',
    styleUrls: ['./confirm-disconnect-xero.component.scss']
})
export class ConfirmDisconnectXeroComponent {
}
